<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 388.4 269" style="enable-background:new 0 0 388.4 269;" xml:space="preserve">
    <path data-async data-duration="10" data-delay="0" class="st4" d="M321.6,280.6H3c-5.4,0-9.8-4.4-9.8-9.8V1.9c0-5.4,4.4-9.8,9.8-9.8h311c2.6,0,5,1,6.8,2.8l64.7,63.8
	c1.9,1.8,2.9,4.3,2.9,6.9v147.8c0,2.6-1,5-2.8,6.8l-57.1,57.3C326.7,279.5,324.2,280.6,321.6,280.6z"/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="315.9,220.6 365.5,171 365.5,93.7 317.7,46 278.4,46 249.9,17.4 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="317,238.5 373.4,182.1 373.4,88.3 321.5,36.4 290,36.4 271.7,18.1 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="294,18.1 302.5,26.5 327.1,26.5 383.2,82.6 383.2,188 316.5,254.7 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="245.4,52.8 268.5,76 268.5,95.6 290.1,95.6 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="226.3,173.5 226.3,188 234.8,196.6 269,196.6 292.6,220.3 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="291.9,147.5 272.1,167.2 248.1,167.2 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="291.9,168.4 286.3,173.9 248.1,173.9 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="219,162.4 201.5,162.4 185.7,146.6 185.7,130.8 152.1,130.8 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="219,168.4 195.9,168.4 179.3,151.8 179.3,138.3 152.1,138.3 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="219,154.6 206.7,154.6 193.8,141.7 193.8,123.5 152.1,123.5 "/>
    <polyline data-async data-duration="10" data-delay="5" class="st0" points="108.1,232.8 117.7,223.3 146.5,223.3 146.5,184.3 "/>
    <rect data-async data-duration="10" data-delay="5" x="219" y="147.5" class="st2" width="29.2" height="26"/>
    <rect data-async data-duration="10" data-delay="5" x="89" y="6.7" class="st2" width="54.1" height="51.3"/>
    <path data-async data-duration="10" data-delay="5" class="st1" d="M273.2,236.3c0,9.4-7.6,17-17,17h-60.3c-9.4,0-17-7.6-17-17c0-9.4,7.6-17,17-17h60.3
      C265.6,219.3,273.2,226.9,273.2,236.3z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M315.9,188c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C314,184.3,315.9,186,315.9,188z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M315.9,75.1c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C314,71.3,315.9,73,315.9,75.1z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M264.5,206.3c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C262.7,202.6,264.5,204.3,264.5,206.3z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M221.9,206.3c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C220.1,202.6,221.9,204.3,221.9,206.3z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M315.9,202.7c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C314,198.9,315.9,200.6,315.9,202.7z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M178.8,206.4c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C176.9,202.7,178.8,204.3,178.8,206.4z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M182.6,97.4c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C180.7,93.7,182.6,95.4,182.6,97.4z"/>
    <path data-async data-duration="10" data-delay="5" class="st0" d="M134.8,69.5c0,2.1-1.9,3.7-4.2,3.7h-14.9c-2.3,0-4.2-1.7-4.2-3.7c0-2.1,1.9-3.7,4.2-3.7h14.9
      C133,65.7,134.8,67.4,134.8,69.5z"/>
    
    <rect data-async data-duration="10" data-delay="5" x="5.8" y="83.3" class="st1" width="146.2" height="101"/>
    <rect data-async data-duration="10" data-delay="5" x="78.9" y="206.3" class="st2" width="29.2" height="49.8"/>
    <circle data-async data-duration="10" data-delay="0" class="st1" cx="195.9" cy="17.4" r="14.4"/>
    <g>
      <circle data-async data-duration="10" data-delay="5" class="st2" cx="223" cy="14.1" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="245.4" cy="14.1" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="267.7" cy="14.1" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="290.1" cy="14.1" r="5.6"/>
    </g>
    <g>
      <circle data-async data-duration="10" data-delay="5" class="st2" cx="241.3" cy="49" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="241.3" cy="69.5" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="219" cy="49" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="219" cy="69.5" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="219" cy="93.7" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="219" cy="114.9" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="241.3" cy="93.7" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="241.3" cy="114.9" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="195.9" cy="49" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="195.9" cy="69.5" r="5.6"/>
    </g>
    <g>
      <circle data-async data-duration="10" data-delay="5" class="st2" cx="133" cy="120.5" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="133" cy="143.4" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="113.7" cy="120.5" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="113.7" cy="143.4" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="94.5" cy="120.5" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="94.5" cy="143.4" r="5.6"/>
    </g>
    <g>
      <circle data-async data-duration="10" data-delay="5" class="st0" cx="335.8" cy="123.5" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="295.7" cy="95.6" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="312.4" cy="95.6" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="295.7" cy="143.4" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="312.4" cy="143.4" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="295.7" cy="164.3" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="312.4" cy="164.3" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="335.8" cy="149" r="5.6"/>
    </g>
    <g>
      <circle data-async data-duration="10" data-delay="5" class="st2" cx="295.7" cy="224.9" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="312.4" cy="224.9" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="312.4" cy="241.8" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st2" cx="312.4" cy="258.6" r="5.6"/>
    </g>
    <g>
      <circle data-async data-duration="10" data-delay="5" class="st0" cx="76.9" cy="14.1" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="76.9" cy="31.9" r="5.6"/>
      <circle data-async data-duration="10" data-delay="0" class="st0" cx="76.9" cy="49.7" r="5.6"/>
    </g>
  </svg>
</template>

<script>
import Vivus from 'vivus';

export default {
  name: 'HomeGraphic',
  data () {
    return {
      locations: {},
      activeLocation: null,
    }
  },
  mounted: function() {
    let myVivus = new Vivus('Layer_1', { duration: 400, type: "scenario-sync" }); // duration is in FRAMES, not milliseconds
    myVivus.play();
  },    
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";


.st0{fill:none;stroke:#2DBDBF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st1{fill:#95A9D6;stroke:#1C1E4B;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st2{fill:#C8D9E9;stroke:#1C1E4B;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st4{opacity:0.5;fill:#C8D9E9;}

svg {
  // max-width: 600px;
  width: 90%;
  opacity: .3;
  @media screen and (max-width: $tablet) {
    width: 100%;
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
